<template>
    <span>
        <template v-if="null === items">
            <base-loader key="loader" />
        </template>
        <template v-else-if="false === items">
            <base-error-message
                v-if="false === items"
                key="error"
            >
                <slot />
            </base-error-message>
        </template>
    </span>
</template>

<script>
export default {
    props: {
        items: {
            type: [Boolean, Object, Array],
            default: null,
        },
    },
};
</script>
